module.exports = __webpack_public_path__ + "static/media/les_dryades.8855d6de.png";